import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, headerColor } from "@clockwise/web-commons/src/styles/color.styles";

////////////////////
// STANDARD STYLES
////////////////////
const container: CSSProperties = {
  borderBottom: `1px solid ${greys.borderGrey}`,
};

const topLine: CSSProperties = {
  padding: `8px 8px 8px 12px`,
};

const body: CSSProperties = {
  paddingBottom: 5,
  paddingLeft: 12,
  paddingRight: 12,
};

const subHeading: CSSProperties = {
  fontSize: 14,
  lineHeight: 1.4,
  color: greys.darkGreyBlue,
  paddingBottom: 5,
};

export const standardStyles = {
  body,
  container,
  subHeading,
  topLine,
};

////////////////////
// TIP STYLES
////////////////////
const tipContainer: CSSProperties = {};

const tipHeader: any = {
  // FIXME: WebkitFontSmoothing
  WebkitFontSmoothing: "antialiased",
};

const tipBody: CSSProperties = {
  ...body,
  paddingTop: 20,
  paddingBottom: 20,
};

const tipBanner: CSSProperties = {
  height: 142,
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
};

const tipSubHeading: any = {
  // FIXME: WebkitFontSmoothing
  fontSize: 14,
  lineHeight: 1.4,
  WebkitFontSmoothing: "antialiased",
};

export const tipStyles = {
  tipContainer,
  tipHeader,
  topLine,
  tipBanner,
  tipBody,
  tipSubHeading,
  headerColor,
};
